export const GET_SIZE_CHART = "GET_SIZE_CHART";
